import React from 'react';
import { Link } from 'react-router-dom';

import { Typography, Grid, Divider } from '@mui/material';

import { downloadImage } from 'js/library/services/StorageManager.js';
import placeholder from 'styles/assets/placeholder/placeholder.gif';

export const OrganizationItem = (data) => {
  const [downloadedImage, setDownloadedImage] = React.useState(null);

  data = data.data;

  function downloadImageOnLoad() {
    if (data.coverImage !== undefined) {
      downloadImage(data.coverImage.split('/')[0], data.coverImage.split('/')[1])
        .then((downloaded) => {
          setDownloadedImage(downloaded);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  return (
    <div key={data.orgID}>
      <Grid container spacing={3} style={{ width: '100%' }}>
        <Grid size={{ xs: 12, md: 5, lg: 5 }}>
          <Link
            to={{
              pathname: '/triibos/',
              search: '?id=' + data.orgID,
              state: data,
            }}
            style={{ textDecoration: 'none' }}
          >
            <img
              width="100%"
              alt="promo"
              onLoad={() => downloadImageOnLoad()}
              className="img-radius"
              src={downloadedImage === null ? placeholder : downloadedImage}
            />
          </Link>
        </Grid>
        <Grid size={{ xs: 12, md: 7, lg: 7 }}>
          <Link
            to={{
              pathname: '/triibos/',
              search: '?id=' + data.orgID,
              state: data,
            }}
            style={{ textDecoration: 'none', lineHeight: 1 }}
          >
            <Typography
              gutterBottom
              variant="h6"
              style={{ color: 'black', fontWeight: 'bolder', lineHeight: 1 }}
            >
              <i>{data.name}</i>
            </Typography>
            <Typography color="secondary" className="limit-text" variant="caption">
              {data.description}
            </Typography>
          </Link>
        </Grid>
      </Grid>

      <Divider style={{ margin: '20px 0px', float: 'right' }} width="80%" />
    </div>
  );
};

export default OrganizationItem;
